import { verify } from 'jsonwebtoken';
import type { UnpackedUserToken } from '@/app_actions/Checkout/entities';
import { pianoIdApi, pianoIdEndpoints } from '@/app_actions/externalApiUtils';

export async function generateUserToken(uid: string): Promise<string> {
  try {
    const tokenResponse = await fetch(`${pianoIdApi(pianoIdEndpoints.getUserToken)}&uid=${uid}`, {
      method: 'POST',
    });

    if (!tokenResponse.ok) {
      const errorText = await tokenResponse.text();
      throw new Error(`Token generation failed: ${errorText}`);
    }

    const tokenResult = await tokenResponse.json();
    return tokenResult.access_token;
  } catch (error) {
    throw new Error(`Failed to generate token: ${error instanceof Error ? error.message : 'Unknown error'}`);
  }
}

export function unpackAndVerifyUserToken(token: string) {
  try {
    const jwtSecret = process.env.PIANO_JWT_SECRET;

    if (!jwtSecret) {
      throw new Error('JWT secret is not defined.');
    }

    return verify(token, Buffer.from(jwtSecret, 'base64')) as UnpackedUserToken;
  } catch (e) {
    throw new Error((e as Error).message);
  }
}
